<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between" style="margin-bottom: 10px">
      <div>
        <p style="font-size: 12px">
          <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.
        </p>
      </div>
      <b-button-group v-if="editableOps">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="refreshGrid"
          >Refresh</b-button
        >
      </b-button-group>
    </div>
    <DxDataGrid
      id="cement-fluid-grid"
      ref="cementFluidGrid"
      :data-source="cementFluidDataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      column-resize-mode="nextColumn"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :cell-hint-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :column-width="100"
      :height="300"
      @row-inserted="savedRows"
      @row-updated="updatedRows"
      @row-removed="removedRows"
    >
      <DxPaging :enabled="false"/>
      <DxSelection mode="single"/>
      <DxScrolling column-rendering-mode="virtual"/>
      <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="row"/>
          <DxColumn
                type="buttons"
                width="120"
              >
                <GridButton name="edit"/>
                <GridButton name="delete"/>
              </DxColumn>
              <DxColumn caption="No." cell-template="rowNoTemplate" width="70" />
              <template #rowNoTemplate="{ data }">
                {{ data.rowIndex + 1 }}
              </template>
      <DxColumn data-field="index" caption="No." sort-order="asc">
        <DxFormItem :visible="false"/>
      </DxColumn>
      <DxColumn data-field="fluidName" caption="Fluid Name" data-type="string" width="200">
        <DxLookup
          :data-source="optionsFluidName"
          value-expr="value"
          display-expr="text"/>
      </DxColumn>
      <DxColumn data-field="fluidType" caption="Fluid Type" data-type="string" />
      <DxColumn data-field="classes" caption="Class" data-type="string" width="200">
        <DxLookup
          :data-source="optionsClass"
          value-expr="value"
          display-expr="text"/>
      </DxColumn>
      <DxColumn data-field="density" caption="Density" data-type="string" />
      <DxColumn data-field="description" caption="Description"  width="200">
        <DxLookup
          :data-source="optionsDescription"
          value-expr="value"
          display-expr="text"/>
      </DxColumn>
      <DxColumn data-field="slurryTopTvd" caption="Slurry top TVD" data-type="number" />
      <DxColumn data-field="slurryBaseTvd" caption="Slurry base TVD" data-type="number" />
      <DxColumn data-field="purpose" caption="Purpose" data-type="string" width="200">
        <DxLookup
          :data-source="optionsPurpose"
          value-expr="value"
          display-expr="text"/>
      </DxColumn>
      <DxColumn data-field="type" caption="Type" data-type="string">
        <DxLookup
          :data-source="optionsType"
          value-expr="value"
          display-expr="text"/>
      </DxColumn>
      <DxColumn data-field="excessMeasurementType" caption="Excess Measurement Type" data-type="string" />
      <DxColumn data-field="excessSlurryPercent" caption="Excess Slurry Percent" data-type="number" />
      <DxColumn data-field="excessSlurryVolume" caption="Excess Slurry Volume" data-type="number" />
      <DxColumn data-field="gaugedAnnularVol" caption="Gauged Annular Vol" data-type="number" />
      <DxColumn data-field="mixWaterRatio" caption="Mix Water Ratio" data-type="number" />
      <DxColumn data-field="yield" caption="Yield" data-type="number" />
      <DxColumn data-field="cementUsedVolume" caption="Cement Used Volume" data-type="number" />
      <DxColumn data-field="otherAmountUsed" caption="Other Amount Used" data-type="number" />
      <DxColumn data-field="totalSlurryVolume" caption="Total Slurry Volume" data-type="number" />
      <DxColumn data-field="totalSlurryInWell" caption="Total Slurry in Well" data-type="number" />
      <DxColumn data-field="totalWaterVolumeUsed" caption="Total Water Volume Used" data-type="number" />
      <DxColumn data-field="calcSacksUsed" caption="Calc Sacks Used" data-type="number" />
      <DxColumn data-field="sacksUsed" caption="Sacks Used" data-type="number" />
      <DxColumn data-field="sackSize" caption="Sack Size" data-type="number" />
    </DxDataGrid>
  </div>
</template>

<script>
import { formMethods } from '@state/helpers'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling,
  DxButton as GridButton
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import CustomStore from 'devextreme/data/custom_store'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import qs from 'querystring'

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    GridButton,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    submitId: {
      type: Number,
      default: undefined,
    },
    editableOps: {
      type: Boolean,
      default: false,
    },
    wellId: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      cementFluidDataSource: null,
      selectedRow: [],
      listItem: [],
      perPage: 10,
      tableBusy: false,
      currentPage: 1,
      cementFluidIsLoading: false, 
      tableFields: [
        'No',
        {
          key: 'fluidName',
          label: 'Fluid Name',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'fluidType',
          label: 'Fluid Type',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'classes',
          label: 'Class',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'density',
          label: 'Density',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'slurryTopTvd',
          label: 'Slurry top TVD',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'slurryBaseTvd',
          label: 'Slurry base TVD',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'purpose',
          label: 'Purpose',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'type',
          label: 'Type',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'excessMeasurementType',
          label: 'Excess Measurement Type',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'excessSlurryPercent',
          label: 'Excess Slurry Percent',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'excessSlurryVolume',
          label: 'Excess Slurry Volume',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'gaugedAnnularVol',
          label: 'Gauged Annular Vol',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'mixWaterRatio',
          label: 'Mix Water Ratio',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'yield',
          label: 'Yield',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'cementUsedVolume',
          label: 'Cement Used Volume',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'otherAmountUsed',
          label: 'Other Amount Used',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'totalSlurryVolume',
          label: 'Total Slurry Volume',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'totalSlurryInWell',
          label: 'Total Slurry in Well',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'totalWaterVolumeUsed',
          label: 'Total Water Volume Used',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'calcSacksUsed',
          label: 'Calc Sacks Used',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'sacksUsed',
          label: 'Sacks Used',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'sackSize',
          label: 'Sack Size',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
      ],
      selectedAction: '',
      form: [],
      show: false,
      fluidNameList: [],
      classList: [],
      descriptionList: [],
      purposeList: [],
      typeList: [],
      optionsFluidName: [],
      optionsClass: [],
      optionsDescription: [],
      optionsPurpose: [],
      optionsType: []
    }
  },

  computed: {
    totalRows: function () {
      return this.listItem.length
    },
  },

  watch: {
    submitId: function (val, oldVal) {
      this.refreshGrid()
    },
  },

  created: function () {
    this.init()
    this.loadAllCombo()
  },

  methods: {
    ...formMethods,
    init() {
      this.cementFluidDataSource = new CustomStore({
        key: 'intId',
        load: () => {
          const url = mapApiUrl('/api/form/activity/cement/fluid/review')
          const params = {submitId: this.submitId, status: 1}
          return axios.get(url, {params: params}).then(response => response.data.data)
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          const url = mapApiUrl('/api/form/activity/cement/fluid/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.intId = key
          const url = mapApiUrl('/api/form/activity/cement/fluid/review/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/activity/cement/fluid/remove')
          return axios.delete(url, {params: {intId: key}})
        },
      })
    },
    refreshGrid() {
      this.$refs.cementFluidGrid.instance.refresh()
    },
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Cementing fluid data has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Cementing fluid data has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Cementing fluid data has been removed.`, width: 500 }, 'success', 3000)
    },
    refreshTableAndCombo() {
      this.tableBusy = true
      this.listItem = []
      this.getActivityCementFluid({
        params: { submitId: this.submitId },
      }).then((resp) => {
        this.listItem = resp.data.data
        let idx=1
        this.listItem.forEach(element => {
          element.id = idx++
        })
        this.tableBusy = false
      })
      this.loadAllCombo()
    },
    loadAllCombo() {
      this.loadComboFluidName()
      this.loadComboClass()
      this.loadComboDescription()
      this.loadComboPurpose()
      this.loadComboType()
    },
    loadComboFluidName() {
      this.fluidNameList = []
      this.getActivityFluidNameList({
        params: { wellId: this.wellId },
      }).then((resp) => {
        let arrDefault = [
          'CaBr2',
          'CaCl2 Water',
          'CD 146 Reformate',
          'Crude Oil',
          'Diesel Fuel',
          'Fresh Water',
          'HCl/HF Acid (Mud Acid)',
          'HCl Acid',
          'KCl Water',
          'Produced Water',
          'QC Oil',
          'Salt Water',
          'SAPP Water',
        ]
        this.fluidNameList = resp.data.data.concat(arrDefault)
        this.optionsFluidName = []
        for (const element of this.fluidNameList) {
          this.optionsFluidName.push({ value: element, text: element })
        }
      })
    },
    loadComboClass() {
      this.classList = []
      this.getActivityClassList({
        params: { wellId: this.wellId },
      }).then((resp) => {
        let def = [
          'CLASS A',
          'CLASS B',
          'CLASS C',
          'CLASS D',
          'CLASS E',
          'CLASS F',
          'CLASS G',
          'CLASS H',
          'DIACEL',
          'DIESEL-OIL',
          'GYPSUM',
          'LATEX',
          'OIL-IN-H2O',
          'POZZOLAN',
          'RESIN',
        ]
        this.classList = resp.data.data.concat(def)
        this.optionsClass = []
        for (const element of this.classList) {
          this.optionsClass.push({ value: element, text: element })
        }
      })
    },
    loadComboDescription() {
      this.descriptionList = []
      this.getActivityDescriptionList({
        params: { wellId: this.wellId },
      }).then((resp) => {
        let def = [
          'BENTONITE ACCEL',
          'BENTONITE EXT.',
          'KCL SYSTEM',
          'LIQUID ADDITIVE ACCEL',
          'LIQUID ADDITIVE EXT.',
          'LOW FLUID LOSS',
          'NEAT',
          'POZZOLAN SALT SYSTEM',
          'POZZOLAN w/ BENTONITE',
          'SALT SYSTEM',
          'SODIUM CHLORIDE',
        ]
        this.descriptionList = resp.data.data.concat(def)
        this.optionsDescription = []
        for (const element of this.descriptionList) {
          this.optionsDescription.push({ value: element, text: element })
        }
      })
    },
    loadComboPurpose() {
      this.purposeList = []
      this.getActivityPurposeList({
        params: { wellId: this.wellId },
      }).then((resp) => {
        let def = [
          'Abandonment Plug',
          'Conductor Support',
          'Filler Cement',
          'Shoe Integrity',
          'Squeeze Perforations',
          'Zonal Isolation',
        ]
        this.purposeList = resp.data.data.concat(def)
        this.optionsPurpose = []
        for (const element of this.purposeList) {
          this.optionsPurpose.push({ value: element, text: element })
        }
      })
    },
    loadComboType() {
      this.typeList = []
      this.getActivityTypeList({
        params: { wellId: this.wellId },
      }).then((resp) => {
        let def = ['LEAD', 'PLUG', 'SQUEEZE', 'TAIL']
        this.typeList = resp.data.data.concat(def)
        this.optionsType = []
        for (const element of this.typeList) {
          this.optionsType.push({ value: element, text: element })
        }
      })
    },
    onRowSelected(item) {
      if (item.length === 0) {
        this.selectedRow = []
        this.$refs.tableData.clearSelected()
        return
      }
      this.selectedRow = item
      this.form = item[0]
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onRowRemoving() {

    },
    saving(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      rowData.submitId = this.submitId
      delete rowData.id
      this.addActivityCementFluid({ params: rowData }).then((resp) => {
          this.refreshTableAndCombo()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
    },

    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] }
        this.removeActivityCementFluid({ params: data }).then((resp) => {
          this.refreshTableAndCombo()
          this.closeModalRemove()
          this.makeToast('Remove data cement fluid success.')
        })
      }
    },
  },
}
</script>